export const DUPLICATE_METER_NUMBER = 'DUPLICATE_METER_NUMBER'

const HTTP_CONFLICT = 409

interface DuplicateMeterNumberResponse {
  code?: string
}

export const isDuplicateMeterNumber = (
  status: number | undefined,
  responseData: DuplicateMeterNumberResponse | undefined,
): boolean => status === HTTP_CONFLICT && responseData?.code === DUPLICATE_METER_NUMBER
